import { useEffect, useState } from 'react'
import './WorkerMien.less'
import useHistory from '@/hooks/useHistory'
// import { useSearchParams } from 'react-router-dom'

const WorkerMien = () => {
  const history = useHistory()

  // const [list, setList] = useState([
  //   {id: '01', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-01.png'},
  //   {id: '02', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-02.png'},
  //   {id: '03', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-03.png'},
  //   {id: '04', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-04.png'},
  // ])
  
  const [imglist, setImglist] = useState([
    {id: '05', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-05.png'},
    {id: '06', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-06.png'},
    {id: '07', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-07.png'},
    {id: '08', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-08.png'},
    {id: '09', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-09.png'},
    {id: '10', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-10.png'},
    {id: '11', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-11.png'},
    {id: '12', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-12.png'},
    {id: '13', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-13.png'},
    {id: '14', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-14.png'},
    {id: '15', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-15.png'},
    {id: '16', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-16.png'},
    {id: '17', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-17.png'},
    {id: '18', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-18.png'},
    {id: '19', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/worker-19.png'},
  ])

  // const [ params ] = useSearchParams()
  // const type = params.getAll('id')[0]

  // const [active, setActive] = useState('1')

  const handleClick = (id) => {
    // localStorage.setItem('steps', active)
    history.push('/WorkerMienDetail?id=' + id)
  }

  // const handleChangeTab = (step) => {
  //   setActive(step)
  // }

  // useEffect(() => {
  //   const step = localStorage.getItem('steps')
  //   if (type === '02') {
  //     setActive('2')
  //   }else if (step) {
  //     setActive(step)
  //     localStorage.removeItem('steps')
  //   }
  // }, [])

  return (
    <div className='pg-worker-mien'>
      <img className='header-img' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/header-bg.png' />
      <div className='pg-worker-mien--container'>
        {/* <div className='tabs'>
          <div className={ active === '1' ? 'tab acitve' : 'tab' } onClick={() => handleChangeTab('1')}>最美建设者</div>
          <div className={ active === '2' ? 'tab acitve' : 'tab' } onClick={() => handleChangeTab('2')}>身边好员工</div>
        </div> */}
        {/* {
          active === '1' ?  */}
          {/* <div className='img-list--wrap'>
            {
              list.map(item => {
                return <div className='worker-img--container' >
                  <img 
                    className='worker-img' 
                    key={item.id}
                    src={ item.url } 
                    onClick={() => handleClick(item.id)}
                  />
                </div>
              })
            }
          </div> */}
          <div>
            {
              imglist.map(item => {
                return <img className='worker-img2' src={item.url} key={item.id} onClick={() => handleClick(item.id)} />
              })
            }
          </div>
        {/* } */}
      </div>
    </div>
  )
}

export default WorkerMien